// extracted by mini-css-extract-plugin
export var actions = "_1f-0";
export var actionsContainer = "_1f-6";
export var border = "_1f-1";
export var childFullHeight = "_1f-d";
export var collapse = "_1f-2";
export var content = "_1f-8";
export var contentChild = "_1f-c";
export var fullscreen = "_1f-a";
export var hasLeftRadius = "_1f-h";
export var headerContainer = "_1f-3";
export var headerRow = "_1f-5";
export var hidePadding = "_1f-9";
export var navCollapsedGap = "_1f-i";
export var noScrollX = "_1f-j";
export var noScrollY = "_1f-k";
export var optOutTopPadding = "_1f-b";
export var pageMain = "_1f-g";
export var pageOuter = "_1f-e";
export var pagePadding = "_1f-7";
export var profile = "_1f-l";
export var profileContainer = "_1f-m";
export var profileImage = "_1f-n";
export var profileMain = "_1f-o";
export var profileSubtitle = "_1f-q";
export var profileTitle = "_1f-p";
export var showLeftPadding = "_1f-f";
export var tabsWrapper = "_1f-4";
export var title = "_1f-r";